import React from "react";

/**
 * Renders title with the `emphasis` substring wrapped in italic accent.
 * Falls back to plain text if emphasis is empty or not found.
 */
export default function TitleWithEmphasis({ text = "", emphasis = "", emphasisClass = "italic text-[#B5523A]" }) {
  if (!text) return null;
  if (!emphasis) return <>{text}</>;
  const idx = text.toLowerCase().indexOf(emphasis.toLowerCase());
  if (idx === -1) return <>{text}</>;
  const before = text.slice(0, idx);
  const match = text.slice(idx, idx + emphasis.length);
  const after = text.slice(idx + emphasis.length);
  return (
    <>
      {before}
      <em className={emphasisClass}>{match}</em>
      {after}
    </>
  );
}
